import React from "react";

const SelectInputField = ({ label, name, value, onChange, options = [], disabled = false, required = false }) => {
    return (
        <div className="mt-2" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "80%" }}>
                <div style={{ fontFamily: "sans-serif", fontSize: "12px", fontWeight: "bold" }}>
                    {label} {required && <span style={{ color: "red" }}>*</span>}
                </div>
                <select
                    name={name}
                    value={value}
                    onChange={onChange}
                    style={{
                        width: "100%",
                        marginTop: "5px",
                        padding: "8px",
                        border: "1px solid #D1D1D1",
                        borderRadius: "5px",
                        outline: "none",
                        backgroundColor: disabled ? "#f5f5f5" : "white",
                        cursor: disabled ? "not-allowed" : "pointer",
                        fontSize: "14px",
                        fontFamily: "sans-serif"
                    }}
                    disabled={disabled}
                >
                    <option value="" hidden>Pilih {label}</option>
                    {options.map((option, index) => (
                        <option key={index} value={option.value} disabled={disabled}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>

    );
};

export default SelectInputField;
